import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const followService = {
  followSeller: async (sellerId) => {
    const response = await api.post(API_ENDPOINTS.FOLLOWS.FOLLOW(sellerId));
    return response.data;
  },

  unfollowSeller: async (sellerId) => {
    const response = await api.delete(API_ENDPOINTS.FOLLOWS.UNFOLLOW(sellerId));
    return response.data;
  },

  checkFollowing: async (sellerId) => {
    const response = await api.get(API_ENDPOINTS.FOLLOWS.CHECK(sellerId));
    return response.data;
  },

  getFollowing: async (params = {}) => {
    const response = await api.get(API_ENDPOINTS.FOLLOWS.FOLLOWING, { params });
    return response.data;
  },

  getFollowingCount: async () => {
    const response = await api.get(API_ENDPOINTS.FOLLOWS.FOLLOWING_COUNT);
    return response.data;
  },

  getFollowers: async (sellerId, params = {}) => {
    const response = await api.get(API_ENDPOINTS.FOLLOWS.FOLLOWERS(sellerId), { params });
    return response.data;
  },

  getFollowersCount: async (sellerId) => {
    const response = await api.get(API_ENDPOINTS.FOLLOWS.FOLLOWERS_COUNT(sellerId));
    return response.data;
  },
};

export default followService;